import { render, staticRenderFns } from "./HowManyCoinsShouldIgive.vue?vue&type=template&id=57b2e824&scoped=true&"
import script from "./HowManyCoinsShouldIgive.vue?vue&type=script&lang=ts&"
export * from "./HowManyCoinsShouldIgive.vue?vue&type=script&lang=ts&"
import style0 from "./HowManyCoinsShouldIgive.vue?vue&type=style&index=0&id=57b2e824&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2e824",
  null
  
)

export default component.exports